import { LOG_LEVELS } from "../constants/LogLevels"
import { extractList, sendToLogServer } from "../core/service/BusinessLogicService"
import { digitalJourneyApigateway } from "../intances/apigateway"

export function getCitiesByCode(tunnelData, { departmentId, languageTag }) {
  const params = new URLSearchParams()
  params.append("departmentId", departmentId)
  if (languageTag) params.append("languageTag", languageTag)

  const API_URL_GET_CITIES = `middle-business-service/api/v2/repository/cities/?`

  return digitalJourneyApigateway(tunnelData)
    .get(API_URL_GET_CITIES + params)
    .then((response) => {
      return extractList(response.data)
    })
    .catch((error) => {
      sendToLogServer(
        LOG_LEVELS.ERROR,
        `An error occured when retrieving cities by code, error message => ${error.message}`
      )
      throw error
    })
}
